export default {
  ERRORS: { HOME_PROGRAM_NOT_FOUND: 'Home Program or client not found', UNKNOW_ERROR: 'Unknown error' },
};
